import { composeNightPulse } from "./nightPulse";

export class RpgSoundtrack {
  constructor() {
    const Context = window.AudioContext || window.webkitAudioContext;
    if (!Context) throw new Error("Music is unavailable in this browser.");
    this.context = new Context({ latencyHint: "playback" });
    this.master = this.context.createGain(); this.master.gain.value = 0;
    this.analyser = this.context.createAnalyser(); this.analyser.fftSize = 1024;
    this.master.connect(this.analyser).connect(this.context.destination);
    this.offset = 0; this.volume = 0.18; this.muted = false; this.disposed = false;
  }

  async play() {
    // Must run directly from the user's play click before rendering the loop.
    await this.context.resume();
    if (this.context.state !== "running") throw new Error("Press play again to enable music.");
    if (!this.bufferPromise) this.bufferPromise = composeNightPulse();
    this.buffer = await this.bufferPromise;
    if (this.disposed) return false;
    if (this.source) return true;
    this.source = this.context.createBufferSource();
    this.source.buffer = this.buffer; this.source.loop = true;
    this.source.connect(this.master);
    this.startedAt = this.context.currentTime;
    this.master.gain.cancelScheduledValues(this.startedAt);
    this.master.gain.setValueAtTime(0, this.startedAt);
    this.master.gain.linearRampToValueAtTime(this.muted ? 0 : this.volume, this.startedAt + 0.25);
    this.source.start(this.startedAt, this.offset);
    return true;
  }

  setVolume(volume, muted) {
    this.volume = Math.max(0, Math.min(1, volume)); this.muted = muted;
    if (!this.disposed) this.master.gain.setTargetAtTime(muted ? 0 : this.volume, this.context.currentTime, 0.03);
  }

  pause() {
    if (!this.source) return;
    this.offset = (this.offset + this.context.currentTime - this.startedAt) % this.buffer.duration;
    this.master.gain.setTargetAtTime(0, this.context.currentTime, 0.008);
    this.source.stop(this.context.currentTime + 0.05);
    this.source = null;
  }

  dispose() {
    if (this.disposed) return;
    this.disposed = true;
    if (this.source) { try { this.source.stop(); } catch { /* already stopped */ } }
    this.source = null;
    this.master.disconnect(); this.analyser.disconnect();
    void this.context.close();
  }
}